import React, { useEffect } from 'react';
import '../../../../sass/apps/commerce/desktop/extra_listings.scss';
import '../../../../sass/components/forms.scss';
import BoostModal from '../../../pages/account/components/BoostModal';

const canGetExtraListings = (currentProduct) => {
  return (
    currentProduct &&
    currentProduct.duration != '1 week' &&
    currentProduct.duration != '2 weeks' &&
    currentProduct.duration != '2 months' &&
    currentProduct.duration != '1 semaine' &&
    currentProduct.duration != '2 mois'
  );
};

const extraListingsSmallPrint = (currentProduct, localisations) => {
  let smallPrintText = '';
  switch (currentProduct.duration) {
    case '1 year':
      smallPrintText = localisations.small_print_1_year;
      break;
    case '6 months':
      smallPrintText = localisations.small_print_6_months;
      break;
    case '4 weeks':
      smallPrintText = localisations.small_print_4_weeks;
      break;
    case '3 months':
      smallPrintText = localisations.small_print_3_months;
      break;
    default:
      smallPrintText = localisations.small_print_na;
  }
  return smallPrintText;
};

const listingRange = [...Array(15).keys()];

const extraListingOptions = (
  availableExtraListings,
  currencySymbol,
  localisations,
) => {
  if (!availableExtraListings) {
    return null;
  }

  if (availableExtraListings.length == 0) {
    return null;
  }

  const { price: standardPrice, id: standardId } = availableExtraListings.find(
    (listing) => !listing.promotion,
  );

  const promotionsActive = availableExtraListings.find(
    (listing) => listing.promotion && listing.promotion.minimum_quantity,
  );

  let discountedPrice;
  let discountedId;

  if (promotionsActive) {
    // eslint-disable-next-line array-callback-return
    availableExtraListings.find((listing) => {
      if (listing.promotion && listing.promotion.minimum_quantity) {
        discountedId = listing.id;
        discountedPrice = listing.price;
      }
    });
  }
  let listingAmount;
  let count;
  return listingRange.map((index) => {
    if (index < 10) {
      count = index + 1;
    } else {
      count = listingAmount + 2;
    }
    listingAmount = count;
    return (
      <option
        value={listingAmount}
        key={count}
        data-id={count < 11 ? standardId : discountedId}
      >
        {count} ({currencySymbol}
        {count < 11
          ? parseFloat(standardPrice)
          : parseFloat(discountedPrice)}{' '}
        {localisations.each})
      </option>
    );
  });
};

const ExtraListings = ({
  addExtraListings,
  currentProduct,
  extraListingsTotal,
  extraListingsCount,
  extraListingsSelectedId,
  availableExtraListings,
  gaLabel,
  gaAction,
  localisations,
  currencySymbol,
  siteId,
  addDefaultExtraListings,
}) => {
  useEffect(() => {
    addDefaultExtraListings();
  }, [addDefaultExtraListings, currentProduct]);

  return (
    <section className="extra-listings-wrapper">
      <div className="extra-listings">
        <div
          className={`extra-listings__picker ${
            siteId == 21 ? 'extra-listings__picker--no-boosts' : ''
          }`}
        >
          <div className="extra-listings__select">
            <label htmlFor="extra_listings" className="extra-listings__label">
              {localisations.extra_listings}
            </label>
            <div className="form-group__select">
              <select
                value={extraListingsCount}
                onChange={(event) => {
                  const selectedOption =
                    event.target.childNodes[event.target.selectedIndex];
                  return addExtraListings(
                    parseInt(event.target.value, 10),
                    selectedOption.dataset.id,
                  );
                }}
                id="extra_listings"
                disabled={!canGetExtraListings(currentProduct)}
              >
                <option value="0" data-id="">
                  {localisations.none_selected}
                </option>
                {extraListingOptions(
                  availableExtraListings,
                  currencySymbol,
                  localisations,
                )}
              </select>
              <span className="form-group__select-icon">
                <i className="far fa-chevron-down" aria-hidden />
              </span>
            </div>
          </div>
          <span className="extra-listings__price">
            {currencySymbol}
            {extraListingsTotal != 0 ? extraListingsTotal.toFixed(2) : 0}
          </span>
        </div>
        {siteId != 21 ? (
          <>
            <p className="extra-listings__price-info">
              {extraListingsSmallPrint(currentProduct, localisations)}
              <br />
              <span className="extra-listings__multi-listings-info">
                {localisations.or_see_our}{' '}
                <a
                  id="proUpgradeLink"
                  href="/my-account/pro-products/monthly/"
                  data-ga-event-category="upgrade"
                  data-ga-event-action="offerer_upgrade_form_multi_ad_packages"
                  data-ga-event-label={gaLabel}
                >
                  {localisations.multi_listing_bundles}
                </a>{' '}
                ({localisations.with_advert_boosts}){' '}
              </span>
            </p>
            <BoostModal />
          </>
        ) : null}
      </div>
    </section>
  );
};

export default ExtraListings;
